<template>
  <div>
    <button @click="active = !active">Tıkla</button>
    <transition name="fade">
      <div class="box" v-if="active">Fade test</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style>
.box {
  position: absolute;
  left: 50%;
  top: 40%;
  width: 100px;
  height: 100px;
  background-color: blue;
  color: wheat;
  padding: 50px;
  border-radius: 10px;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 1s;
}

.fade-leave {
}

.fade-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
</style>
